import React from "react";
import { useApp } from "@/context/AppContext";
import { Megaphone, AlertTriangle, Truck, Gift } from "lucide-react";

export default function AnnouncementBar() {
  const { settings, storeStatus, t, subtotal, minOrder, serviceFee, cart } = useApp();
  if (!settings) return null;

  const hasItems = cart && cart.length > 0;
  const remaining = Math.max(0, Number(minOrder) - Number(subtotal || 0));
  const feeActive = hasItems && remaining > 0;
  const feeWaived = hasItems && remaining === 0;

  return (
    <div className="w-full">
      {storeStatus.storeOpen === false && (
        <div
          data-testid="store-closed-banner"
          className="bg-red-600 text-white text-sm py-2 px-4 text-center flex items-center justify-center gap-2"
        >
          <AlertTriangle className="w-4 h-4" />
          <span className="font-semibold">
            {t("store_closed_desc", { open: settings.store_open_hour, close: settings.store_close_hour })}
          </span>
        </div>
      )}
      {storeStatus.storeOpen && !storeStatus.deliveryOpen && (
        <div
          data-testid="delivery-closed-banner"
          className="bg-[#E5A024] text-white text-sm py-2 px-4 text-center"
        >
          <span className="font-semibold">
            {t("delivery_closed_desc", { start: settings.delivery_start_hour, end: settings.delivery_end_hour })}
          </span>
        </div>
      )}

      {/* Delivery fee awareness — always visible on top for clarity */}
      {feeWaived ? (
        <div
          data-testid="fee-bar-waived"
          className="bg-[#2E5A36] text-[#FAF7F2] text-sm py-2 px-4 text-center flex items-center justify-center gap-2"
        >
          <Gift className="w-4 h-4 text-[#E5A024]" />
          <span className="font-heading font-bold">
            {t("free_delivery_active")}
          </span>
        </div>
      ) : (
        <div
          data-testid="fee-bar-info"
          className="bg-[#1B2A22] text-[#FAF7F2] text-xs sm:text-sm py-2 px-4 text-center flex items-center justify-center gap-2"
        >
          <Truck className="w-4 h-4 text-[#E5A024]" />
          <span className="font-semibold">
            {feeActive
              ? t("fee_bar_active", {
                  fee: Number(serviceFee).toFixed(0),
                  remaining: remaining.toFixed(2),
                  min: Number(minOrder).toFixed(0),
                })
              : t("fee_bar_default", {
                  fee: Number(serviceFee).toFixed(0),
                  min: Number(minOrder).toFixed(0),
                })}
          </span>
        </div>
      )}

      {settings.announcements?.length > 0 && (
        <div
          data-testid="announcement-bar"
          className="bg-[#2E5A36] text-[#FAF7F2] py-2 overflow-hidden"
        >
          <div className="max-w-7xl mx-auto px-4 flex items-center gap-3 text-sm">
            <Megaphone className="w-4 h-4 shrink-0 text-[#E5A024]" />
            <div className="flex-1 overflow-hidden">
              <div className="flex gap-8 whitespace-nowrap animate-[marquee_25s_linear_infinite]">
                {[...settings.announcements, ...settings.announcements].map((a, i) => (
                  <span key={i} className="font-semibold">
                    {a}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
      <style>{`
        @keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
      `}</style>
    </div>
  );
}
